import { useEffect, useState } from "react";

// Breakpoint mobile aligné sur le `lg` de Tailwind (1024px). En dessous, on rend
// des variantes mobiles allégées ; au-delà, le rendu desktop reste inchangé.
const MOBILE_QUERY = "(max-width: 1023px)";

/**
 * Indique si le viewport est en mode "mobile" (< 1024px).
 * État initial évalué de façon synchrone pour éviter tout flash de rendu.
 */
export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined" || !window.matchMedia) return false;
        return window.matchMedia(MOBILE_QUERY).matches;
    });

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return;
        const mql = window.matchMedia(MOBILE_QUERY);
        const onChange = (e) => setIsMobile(e.matches);
        mql.addEventListener("change", onChange);
        // Resynchronise au montage au cas où le viewport aurait changé entre-temps.
        setIsMobile(mql.matches);
        return () => mql.removeEventListener("change", onChange);
    }, []);

    return isMobile;
}
